var cov_2on7lta0xx = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Progress/Popup.tsx",
      hash = "b19db24ec5971134812dad6ae64b2cd46ecab23a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Progress/Popup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 25
        },
        end: {
          line: 6,
          column: 27
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 26
        }
      },
      "2": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 32
        }
      },
      "3": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 18
        }
      },
      "4": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 13,
          column: 55
        }
      },
      "5": {
        start: {
          line: 12,
          column: 35
        },
        end: {
          line: 12,
          column: 89
        }
      },
      "6": {
        start: {
          line: 13,
          column: 9
        },
        end: {
          line: 13,
          column: 55
        }
      },
      "7": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "8": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 35
        }
      },
      "9": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 13,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 13,
            column: 55
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 13,
            column: 55
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 7
          },
          end: {
            line: 15,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 24
          }
        }, {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 15,
            column: 33
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 16,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 41
          },
          end: {
            line: 16,
            column: 46
          }
        }, {
          start: {
            line: 16,
            column: 49
          },
          end: {
            line: 16,
            column: 55
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Progress/Popup.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { progressClass } from './styles';
import { isRTL } from '../config';
var ROTATE_MAX_ANGLE = (cov_2on7lta0xx.s[0]++, 15);
var PROGRESS_CENTER = (cov_2on7lta0xx.s[1]++, 60);

var Popup =
/*#__PURE__*/
function (_ref) {
  _inherits(Popup, _ref);

  var _super = _createSuper2(Popup);

  function Popup() {
    _classCallCheck(this, Popup);

    return _super.apply(this, arguments);
  }

  _createClass(Popup, [{
    key: "getStyle",
    value: function getStyle() {
      var _ref3;

      cov_2on7lta0xx.f[0]++;

      var _ref2 = (cov_2on7lta0xx.s[2]++, this.props),
          value = _ref2.value;

      var rotate = (cov_2on7lta0xx.s[3]++, 0);
      cov_2on7lta0xx.s[4]++;

      if (value <= PROGRESS_CENTER) {
        cov_2on7lta0xx.b[0][0]++;
        cov_2on7lta0xx.s[5]++;
        rotate = ROTATE_MAX_ANGLE * (value / PROGRESS_CENTER);
      } else {
        cov_2on7lta0xx.b[0][1]++;
        cov_2on7lta0xx.s[6]++;
        rotate = (1 - value / 100) * ROTATE_MAX_ANGLE;
      }

      cov_2on7lta0xx.s[7]++;
      return _ref3 = {}, _defineProperty(_ref3, isRTL() ? (cov_2on7lta0xx.b[1][0]++, 'right') : (cov_2on7lta0xx.b[1][1]++, 'left'), "".concat(value, "%")), _defineProperty(_ref3, "transform", "translateX(".concat(isRTL() ? (cov_2on7lta0xx.b[2][0]++, '50%') : (cov_2on7lta0xx.b[2][1]++, '-50%'), ") rotate(").concat(rotate, "deg)")), _ref3;
    }
  }, {
    key: "render",
    value: function render() {
      cov_2on7lta0xx.f[1]++;

      var _ref4 = (cov_2on7lta0xx.s[8]++, this.props),
          children = _ref4.children;

      cov_2on7lta0xx.s[9]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: progressClass('popup'),
          style: this.getStyle(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: progressClass('value'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 9
          }
        }, children),
        /*#__PURE__*/
        React.createElement("span", {
          className: progressClass('arrow'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25,
            columnNumber: 9
          }
        }))
      );
    }
  }]);

  return Popup;
}((React.Component));

export { Popup as default };